Postlogin = (function (self) {
    self.CareersViewed = {};
    const me = self.CareersViewed;

    me.$table = $('#careers-viewed-table');

    me.initTable = function () {
        const userId = me.$table.attr('data-user-id');
        const currentUserId = me.$table.attr('data-current-user-id');
        const userFirstName = me.$table.attr('data-user-first-name');

        me.$table.bootstrapTable({
            formatNoMatches() {
                if (userId === currentUserId) {
                    return 'You have not yet viewed any career profiles!';
                }

                return `${userFirstName} has not yet viewed any career profiles.`;
            },
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'activity_log_id',
            minimumCountColumns: '2',
            pagination: true,
            searchAlign: 'left',
            search: true,
            sortName: 'date_viewed',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: userId === currentUserId ? '/my-profile/careers-viewed/json/' : `/users/${userId}/careers-viewed/json/`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const myParams = {};
                myParams.search_term = params.searchText;
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;

                return myParams;
            },
            columns: [
                {
                    title: 'Date Viewed',
                    field: 'date_viewed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Cluster',
                    field: 'cluster_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Career',
                    field: 'career_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                me.$table.closest('.light-blur').removeClass('light-blur');
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                formattedResult.rows.map((row) => Jr.Utils.convertRowDate(row, 'l LT', []));

                return formattedResult;
            },
            onLoadSuccess() {},
            rowStyle() {
                const classes = '';

                return {
                    classes,
                };
            },
        });
    };

    me.init = function () {
        me.initTable();
    };

    return self;
}(Postlogin || {}));
